/**
 * PublicPatientRegistrationAPI.js
 *
 * Cliente dos endpoints públicos (sem autenticação) do link de cadastro.
 * Usado pela PublicPatientRegistrationPage em /cadastro/:token
 *
 * Endpoints (ver docs/features/patient-registration-link/README.md):
 *   - public/patient-registration/get.php    (confere o token + identidade da clínica)
 *   - public/patient-registration/submit.php (envia o cadastro do paciente)
 */

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://www.gabriela.app.br/api/';
const PUBLIC_REGISTRATION_BASE = BASE_URL + 'public/patient-registration/';

const CONNECTION_ERROR = {
    success: false,
    status: 'error',
    error: 'Erro de conexão. Verifique sua internet e tente novamente.',
};

const postForm = (endpoint, fields, callback) => {
    const body = Object.entries(fields)
        .map(([key, value]) => key + '=' + encodeURIComponent(value ?? ''))
        .join('&');

    fetch(PUBLIC_REGISTRATION_BASE + endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
    })
        .then((res) => res.json())
        .then((data) => callback(data))
        .catch(() => callback(CONNECTION_ERROR));
};

/**
 * Confere o link e devolve a clínica.
 *
 * @param {string} token
 * @param {(res: {
 *   success: boolean,
 *   status: 'active' | 'used' | 'expired' | 'invalid' | 'blocked' | 'error',
 *   company?: { id: number, name: string, logo: string, city: string, state: string },
 *   error?: string,
 * }) => void} callback
 */
export const GetPublicPatientRegistrationAPI = (token, callback) => {
    postForm('get.php', { token }, callback);
};

/**
 * Envia o cadastro preenchido pelo paciente.
 *
 * @param {string} token
 * @param {object} data  campos do formulário (name, phone, countryCode, cpf, birthday dd/mm/aaaa, ...)
 * @param {(res: {
 *   success: boolean,
 *   status: 'done' | 'validation' | 'used' | 'expired' | 'invalid' | 'blocked' | 'error',
 *   errors?: Object<string, string>,
 *   error?: string,
 * }) => void} callback
 */
export const SubmitPublicPatientRegistrationAPI = (token, data, callback) => {
    postForm('submit.php', { ...data, token }, callback);
};
